/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocationCountryCode } from '../models/LocationCountryCode';
import type { LocationLocality } from '../models/LocationLocality';
import type { LocationRegion } from '../models/LocationRegion';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocationService {
    /**
     * @param countryCode
     * @returns LocationRegion Ok
     * @throws ApiError
     */
    public static listRegions(
        countryCode?: LocationCountryCode,
    ): CancelablePromise<Array<LocationRegion>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/location/regions',
            query: {
                'countryCode': countryCode,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
    /**
     * @param countryCode
     * @param regionCode
     * @returns LocationLocality Ok
     * @throws ApiError
     */
    public static listLocalities(
        countryCode?: LocationCountryCode,
        regionCode?: string,
    ): CancelablePromise<Array<LocationLocality>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/location/localities',
            query: {
                'countryCode': countryCode,
                'regionCode': regionCode,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
            },
        });
    }
}
